module.exports = __webpack_public_path__ + "img/dg_icon_3.fce4812a.png";